import apiCall from "../../../utility/api";
import { fetchAutomationList, fetchAutomationListCnt } from "../../automation/automation_common_func";

const getRemediationList = async (whereCondition: object, limit: number | null = null, offset: number | null = null, setTableData: any) => {
    try {
        const { data, status } = await fetchAutomationList(whereCondition, limit, offset);

        if (status === 'success' && data.length > 0) {
            setTableData(data);
        } else {
            setTableData([]);
        }
    } catch (error) {
        console.log("fetchdartTemplateList error=", error);
        setTableData([]);
    }
};

const getRemediationListCnt = async (whereCondition: object, setTotalRecords: any, setTotalPages: any) => {
    try {
        const { data, status } = await fetchAutomationListCnt(whereCondition);

        if (status === 'success' && data) {
            setTotalRecords(data.totalRecords);
            setTotalPages(data.totalPages);
        } else {
            setTotalRecords(0);
            setTotalPages(1);
        }
    } catch (error) {
        console.log("getRemediationListCnt error=", error);
        setTotalRecords(0);
        setTotalPages(1);
    }
}

const getExportData = async (condition: object, setExportDetails: any) => {
    try {
        const { status, data } = await apiCall(`/remediation/getList`, condition);

        if (status === 'success' && data.length > 0) {
            setExportDetails(data);
        } else {
            setExportDetails([]);
        }
    } catch (error) {
        console.log("remediation getExportData error=", error);
        setExportDetails([]);
    }
}

const getGroupsListCnt = async (whereCondition: any, setTotalRecords: any, setTotalPages: any) => {
    try {
        const { data, status } = await apiCall(`/groups/getCount`, whereCondition);

        if (status === 'success' && data) {
            setTotalRecords(data.totalRecords);
            setTotalPages(data.totalPages);
        } else {
            setTotalRecords(0);
            setTotalPages(1);
        }
    } catch (error) {
        console.log("getGroupsListCnt error=", error);
        setTotalRecords(0);
        setTotalPages(1);
    }
};

export { getRemediationList, getRemediationListCnt, getExportData, getGroupsListCnt }